import { GET_ADMIN_COMPANY_REQUEST,GET_ADMIN_COMPANY_SUCCESS,GET_ADMIN_COMPANY_ERROR,ADD_ADMIN_COMPANY_ERROR,ADD_ADMIN_COMPANY_REQUEST,ADD_ADMIN_COMPANY_SUCCESS,
    UPDATE_ADMIN_COMPANY_ERROR,UPDATE_ADMIN_COMPANY_REQUEST,UPDATE_ADMIN_COMPANY_SUCCESS,DELETE_ADMIN_COMPANY_ERROR,DELETE_ADMIN_COMPANY_REQUEST,DELETE_ADMIN_COMPANY_SUCCESS
 } from "../actions/types";


 
 export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_ADMIN_COMPANY_REQUEST:
        return {
          loading: true,
        };
      case GET_ADMIN_COMPANY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ADMIN_COMPANY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
        case ADD_ADMIN_COMPANY_REQUEST:
          return {
              loading: true,
          };
      case ADD_ADMIN_COMPANY_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case ADD_ADMIN_COMPANY_ERROR:
          return {
              ...state,
              loading: false
          };
          case UPDATE_ADMIN_COMPANY_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_ADMIN_COMPANY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_ADMIN_COMPANY_ERROR:
            return {
                ...state,
                loading: false
            };
            case DELETE_ADMIN_COMPANY_REQUEST:
              return {
                  loading: true,
              };
          case DELETE_ADMIN_COMPANY_SUCCESS:
              return {
                  ...state,
                  loading: false,
                  payload: [payload],
              };
          case DELETE_ADMIN_COMPANY_ERROR:
              return {
                  ...state,
                  loading: false
              };

      default:
        return state;
    }
  }
  